export const LOGIN_MAIN_URL = "/login/main";
export const LOGIN_SIGNUP_URL = "/login/signup";
export const LOGIN_QR_URL = "/login/qr";

export const HOME_MAIN_URL = "/schedule"; // 교회 일정 (이전: /home/main)
export const SCHEDULE_URL = "/schedule";

export const MYPAGE_MAIN_URL = "/mypage/main";

export const RESERVATION_MAIN_URL = "/reservation/main";

export const DASHBOARD_URL = "/dashboard";
export const ADMIN_MAIN_URL = "/admin/main";
export const CHART_URL = "/chart";
export const REDIRECT_URI = "/kakao/auth";
export const VIEW_URI = "/view/main/:plcCd";

export const YOUTH_URL = "/youth";
